import { computed, makeObservable, observable, runInAction } from 'mobx';
import { Property as PropertyModel } from '@data/models';
import { PropertyService } from '@data/api';
import Accommodations from '../Accommodations';
import Addons from '../Addons';
import AvailabilityCalendar from '../AvailabilityCalendar';
import Guests from '../Guests';
import Payment from '../Payment';
import Cart from '../Cart';
import Reservation from '../Reservation';
import Store from '@data/stores/Store';
import { Amenity } from '@data/types/common';

export default class Property {
  reservation = new Reservation();
  accommodations = new Accommodations();
  addons = new Addons();
  availabilityCalendar = new AvailabilityCalendar();
  guests = new Guests();
  payment = new Payment();
  cart = new Cart();

  @observable model: PropertyModel | null = null;

  constructor() {
    makeObservable(this);
  }

  init() {
    this.cart.init();
    this.accommodations.init();
  }

  get = async (code?: string) => {
    runInAction(() => {
      this.model = null;
    });

    const property = await PropertyService.getProperty(code);

    runInAction(() => {
      this.model = property;
      if (property.notFound) {
        window.location.href = '/404';
      }
    });

    return property;
  };

  @computed private get language() {
    return Store.environment.language;
  }

  @computed get propertyFeatures() {
    return this.model?.amenities.map(
      ({ lang, name, slug }) =>
        ({
          name: lang?.getText(this.language) || name,
          slug,
        } as Amenity)
    );
  }

  @computed get propertyAdditionalFeatures() {
    return this.model?.additionalAmenities.map(
      ({ name }) =>
        ({
          name,
        } as Amenity)
    );
  }

  @computed get description() {
    return this.model?.description.getText(this.language);
  }

  @computed get termsAndConditions() {
    return this.model?.termsAndConditions.getText(this.language);
  }
}
